import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  CheckInFlightIdObjectRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineCheckInFlightIdObjects,
  combineJourneyElementCommons,
  combineJourneys,
  combineJourneyTravelers,
  createAcceptance,
  createJourney,
  createJourneyElement,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  seatmap,
} from '../../mock/data';

const journey = createJourney({
  template: {
    type: 'standalone',
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.MAN,
      JourneyTravelerRepository.WOMAN]).items,
    flights: combineCheckInFlightIdObjects([
      CheckInFlightIdObjectRepository.FRA_NCE]).items,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          }
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          }
        }
      }
    ]).items,
    acceptance: {
      isAccepted: false,
      isPartial: false
    }
  }
});

const journeyElementIds = journey.journeyElements.map((je: JourneyElementCommon) => je.id);

const partialAcceptedjourney = createJourney({
  template: {
    ...journey,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          acceptanceEligibility: {
            status: 'eligible',
            reasons: []
          }
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          checkInStatus: 'accepted',
          seat: {
            seatNumber: '1A',
            cabin: 'Y',
            seatAvailabilityStatus: 'available'
          }
        }
      }]).items,
    acceptance: createAcceptance({
      template: {
        checkedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-1-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        notCheckedInJourneyElements: [
          {
            id: 'JOURNEY-ELEMENT-0-MOCK',
            journeyElement: createJourneyElement()
          }
        ],
        isAccepted: false,
        isPartial: true
      }
    })
  }
});

const acceptedJourney = createJourney({
  template: {
    ...journey,
    travelers: combineJourneyTravelers([
      JourneyTravelerRepository.WOMAN]).items,
    journeyElements: combineJourneyElementCommons([{
      journeyElement: {
        traveler: {
          id: 'JOURNEY-TRAVELER-0-MOCK'
        },
        flightId: 'CHECK-IN-FLIGHT-0-MOCK',
        checkInStatus: 'accepted',
        seat: {
          seatNumber: '4F',
          cabin: 'Y',
          seatAvailabilityStatus: 'available'
        }
      }
    }]).items,
    acceptance: {
      checkedInJourneyElements: [{
        id: 'JOURNEY-ELEMENT-0-MOCK',
        journeyElement: createJourneyElement()
      }],
      isAccepted: true,
      isPartial: false
    }
  }
});

export const ow1journey2AdtUnselectedPassengerSeat: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(combineJourneys([partialAcceptedjourney]).items, 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
